<template>
    <div class="p-1 dropdown" style="min-height: 36px;">
      <div></div>
      <div :style="skin.main_leagues.header" 
          class="m-auto p-1 btn dropdown-toggle extra" data-bs-toggle="dropdown" aria-expanded="false">
          <span   :class="'phoca-flag ' + getFlagClass(language)" 
                  style="width:22px; 
                  height:14px; 
                  flex-shrink: 0;
                  font-size:small">
          </span>    
          {{ skin.languages[language].name }}
          <div @click="toggleAngleRow" class="angle-row">
              <i v-if="angleRowProp === true" class="fa-solid fa-angle-up" aria-hidden="true"></i>
              <i v-else class="fa-solid fa-angle-down"></i>
          </div>
      </div>
          <ul class="dropdown-menu dropdown-custom">
              <li class="li-custom" v-for="(lang, index) in Object.keys(skin.languages)" :key="index">
                  <button v-if="skin.languages[lang].enabled" 
                          class="dropdown-item button-custom" 
                          :class="['drowdown-item', 'button-custom', {active: lang == language}]"
                          type="button" 
                          @click="change_language(lang)">
                      <span :class="'phoca-flag ' + getFlagClass(lang)" style="width:22px; height:14px; flex-shrink: 0;font-size:small"></span>    
                      {{ skin.languages[lang].name }}
                  </button>
              </li>
          </ul>
      <div></div>
      </div>
  </template>
  
  <script>
  export default {
      name:"language_selector",
      props:['skin','language', 'angleRowProp'],
      data(){
          return {
          }
      },
      methods:{
          toggleAngleRow() {
              this.$emit('update-angle-row', !this.angleRowProp);
          },
          change_language(lg){
              this.$store.dispatch('setLanguage', lg);
          },
          getFlagClass(language) {
              // Define las clases de las banderas según los códigos de idioma
              const flagClasses = {
              'es': 'es',
              'en': 'gb',
              'fr': 'fr', // Agrega la clase correspondiente para francés
              'pt': 'br',
              // Agrega más códigos y clases según sea necesario
              };
  
              return flagClasses[language] || 'default-flag'; // Si no se encuentra, devuelve una clase de bandera predeterminada
          },
      }
  }
  </script>
  
  <style scoped>
      .extra {
          display: flex;
          gap: 10px;
          align-items: center;
      }
      .dropdown-custom {
          background: #18242f;
          min-width: 100%;
          max-height: 25vh;
          margin-top: 1px;
          padding: 10px;
          border-radius: 4px;
          box-shadow: 0 0 10px 3px #0000004d, inset 0 0 0 300px rgba(255, 255, 255, 0.05);
          color: #fff;
      }
      .li-custom {
          padding: 3px 0px 3px 0px;
      }
      .button-custom {
          background: #ffffff1a;
          border-radius: 4px;
          color: #fff9;
          font-size: 12px;
          display: flex;
          gap: 10px;
      }
      .button-custom:hover {
          background: #fff3;
      }
      .active {
          background: #fff3;
          color: #fff;
      }
      .dropdown-toggle::after {
          display: none; 
      }
      .angle-row {
          font-weight: 0;
          font-size: 8px;
          width: auto;
          color: #fffc;
      }
  </style>